import React, { useRef, useState } from "react";
import { inject, observer } from "mobx-react";
import { fn_connectDlvAppInit } from "function/FnBodyDelivery";
import { useMappingMutaion } from "views/setting/hooks/useMappingMutaion";
import { Modal } from "components/modal/compound/Modal";
import { Button } from "components/ui/Button";
import modalStore from "stores/ModalStore";

interface ListItem {
  vendorId: number;
  vendorName: string;
  mapped: boolean;
}
const DeliveryConnectPosPick = ({ rootStore }: { rootStore: any }) => {
  const { layerStore, settingStore } = rootStore;
  const title = layerStore.title();
  const { mutate: updateOrderMapping } = useMappingMutaion(rootStore);

  const [isOptionSelected, setIsOptionSelected] = useState<boolean>(false);
  const [selectedLiIndex, setSelectedLiIndex] = useState<number | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const buttonClass =
    isOptionSelected || ["BMN", "WMP", "JNJ", "NBG", "HPD", "MKB"].includes(layerStore.tp) ? "on" : "off";

  // 취소 버튼 클릭 핸들러
  const handleCancel = () => {
    modalStore.closeModal("DeliveryConnectPosPick");
    fn_connectDlvAppInit(rootStore);
    setIsOptionSelected(false);
    setSelectedLiIndex(null);
  };

  // 리스트 선택 핸들러
  const handleSelectList = (item: ListItem) => {
    setIsOptionSelected(true);
    setSelectedLiIndex(item.vendorId);
    layerStore.setMappingAction(!item.mapped);
    layerStore.setYgyShopItem("vendorId", item.vendorId);
    layerStore.setYgyShopItem("vendorNm", item.vendorName);
  };

  // 연락처 입력 핸들러
  const handlePhoneNumChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleanedValue = e.target.value.replace(/\D/g, "");
    settingStore.setDlvRegistInfo("telNo", cleanedValue);
  };

  // 서브타이틀
  const getSubTitle = () => {
    const hasConnect = ["YGY", "DDY", "OTA"];
    if (hasConnect.includes(layerStore.tp)) {
      return <p>{title} 가게를 선택하세요</p>;
    }
    return (
      <>
        <p>원격 {layerStore.getMappingAction ? "설치" : "해제"}가 필요합니다(약 10분 소요)</p>
        <p>설치 가능한 시간과 연락처를 적어주세요</p>
      </>
    );
  };

  // 리스트 위로 이동
  const onUpClick = () => {
    if (scrollContainerRef.current) {
      (scrollContainerRef.current as HTMLElement).scrollTop -= 25;
    }
  };

  // 리스트 아래로 이동
  const onDownClick = () => {
    if (scrollContainerRef.current) {
      (scrollContainerRef.current as HTMLElement).scrollTop += 25;
    }
  };

  const handleConnetClick = () => {
    const hasConnect = ["YGY", "DDY", "OTA"];
    if (hasConnect.includes(layerStore.tp)) {
      layerStore.setLayerAlertType("yogiyo_connect");
      layerStore.setLayerAlertView(true);
    } else {
      if (layerStore.getMappingAction) {
        const tel = settingStore.getDlvRegistInfo.telNo;
        const phoneNumberCheck = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/;

        if (!tel.match(phoneNumberCheck)) {
          layerStore.setLayerPhoneNo(true);
          return false;
        }
      }
      updateOrderMapping({
        bizNo: settingStore.getShopBizNo,
        action: layerStore.getMappingAction,
        cd: layerStore.getYgyShopItem.vendorId,
        posNo: "",
      });
    }

    setIsOptionSelected(false);
    setSelectedLiIndex(null);
    if (scrollContainerRef.current) {
      (scrollContainerRef.current as HTMLElement).scrollTop = 0;
    }
  };

  const Content = () => {
    const list = settingStore.getDdyShopList;
    
    if (["YGY", "YGY_FAIL", "DDY", "OTA"].includes(layerStore.tp)) {
      return (
        <>
          <div>{title} 가게 목록</div>
          <div className="yogiyo_list">
            <div className="scroll_area" ref={scrollContainerRef}>
              {list.length > 0 &&
                list.map((item: ListItem, index: number) => (
                  <li
                    key={index}
                    className={selectedLiIndex === item.vendorId ? "on" : ""}
                    onClick={() => handleSelectList(item)}
                    style={index === list.length - 1 && list.length > 5 ? { border: "none" } : {}}
                  >
                    {item.vendorName}
                    {item.mapped ? (
                      <span className={selectedLiIndex === item.vendorId ? "con onn" : "con"}>연동중</span>
                    ) : (
                      <span className={selectedLiIndex === item.vendorId ? "discon onn" : "discon"}>미연동</span>
                    )}
                  </li>
                ))}
            </div>
            <div className="btn_wrap">
              <button className="btn_up" onClick={onUpClick}>
                <div className="ico_up"></div>
              </button>
              <button className="btn_down" onClick={onDownClick}>
                <div className="ico_down"></div>
              </button>
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <div>연락처</div>
        <input
          id="bmPhoneNum"
          type="text"
          className="num"
          placeholder="숫자만 입력하세요"
          onChange={handlePhoneNumChange}
        />
        {/* 에러메시지 */}
        <div className={layerStore.getLayerPhoneNo ? "error_message bm" : "hide"}>
          <div className="icon bm"></div>
          <div className="txt">
            <p>연락처를 다시 확인해주세요</p>
          </div>
        </div>
        <div className="box">설치 가능 시간</div>
        <input
          id="setTime"
          type="text"
          className="num"
          placeholder="(ex) 23일 오후 2시"
          onChange={event => settingStore.setDlvRegistInfo("contactPossibleTime", event.target.value)}
          maxLength={20}
        />
        <p className="info">※ 평일 9:30~18:00 (점심시간 12:30~13:30 제외)</p>
      </>
    );
  };

  return (
    <Modal.BackGround containerWidth="374px" border={true} className="relative">
      <div className="layer_content">
        <div className="wrap !border-none">
          <Modal.Header title={`${title} 연동`} onClose={handleCancel} />
          <Modal.Content>
            <div className="content_business !p-0">
              {getSubTitle()}
              <div className="input">{Content()}</div>
            </div>
          </Modal.Content>
          <Modal.Divider className="!m-4" />
          <Modal.Bottom className="flex justify-between !p-4">
            <Button onClick={handleCancel} variant="white">
              취소
            </Button>
            <Button
              className={buttonClass}
              disabled={buttonClass === "off"}
              onClick={handleConnetClick}
              variant="black"
              size="sm"
            >
              {layerStore.tp === "BMN" ? "확인" : layerStore.getMappingAction ? "연동하기" : "해제하기"}
            </Button>
          </Modal.Bottom>
        </div>
      </div>
    </Modal.BackGround>
  );
};

export default inject("rootStore")(observer(DeliveryConnectPosPick));
